export const COLLABORATION_IMAGE = 'IMAGE';
export const COLLABORATION_DOCUMENT = 'DOCUMENT';
export const COLLABORATION_DEPARTMENT = 'DEPARTMENT';
export const COLLABORATION_REMARK = 'REMARK';
export const COLLABORATION_PARTIAL_CLOSE = 'CLOSE';
export const COLLABORATION_OPEN_ISSUE = 'OPEN_ISSUE';
export const COLLABORATION_SHARED_ISSUE = 'SHARED_ISSUE';
export const COLLABORATION_ADD_CC = 'ADD_CC';
export const COLLABORATION_REOPEN = 'REOPEN';
